import axios from "axios";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { END_POINT } from "config/environment";
import { IGeneralProps } from "types";
import { message } from "antd";

export const QUERY_KEY_FOR_SHORTLISTED_APPLICANTS = "shortlisted-applicants";


const getShortListed = async (props: IGeneralProps) => {
  const id = props.id;
  const url = `${END_POINT.BASE_URL}/v1/shortlisted-talents/${id}`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };

  const res = await axios.get(url, config);
  return res.data;
};

export const useGetShortListed = ({ id, token }: IGeneralProps) => {
  return useQuery([QUERY_KEY_FOR_SHORTLISTED_APPLICANTS, id], () =>
    getShortListed({ id, token })
  );
};


const shortlistTalent = async ({
  listingId,
  talentId,
  token,
}: {
  listingId: string;
  talentId: string;
  token: string;
}) => {
  const url = `${END_POINT.BASE_URL}/v1/save-shortlisted-talents/${listingId}`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const body = { talent_id: talentId };

  const res = await axios.post(url, body, config);
  return res.data;
};

export const useShortlistTalent = () => {
  const queryClient = useQueryClient();

  return useMutation(shortlistTalent, {
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries([
        QUERY_KEY_FOR_SHORTLISTED_APPLICANTS,
        variables.listingId,
      ]);
      message.success("Talent added to shortlist");
    },
    onError: () => {
      message.error("Failed to shortlist talent");
    },
  });
};

const unshortlistTalent = async ({
  listingId,
  talentId,
  token,
}: {
  listingId: string;
  talentId: string;
  token: string;
}) => {
  const url = `${END_POINT.BASE_URL}/v1/unshortlist-talents/${listingId}`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await axios.post(url, { talent_id: talentId }, config);
  return res.data;
};

export const useUnshortlistTalent = () => {
  const queryClient = useQueryClient();

  return useMutation(unshortlistTalent, {
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries([
        QUERY_KEY_FOR_SHORTLISTED_APPLICANTS,
        variables.listingId,
      ]);
    },
    onError: (err: any) => {
      message.error(
        err?.response?.data?.error ||
          err?.response?.data?.message ||
          "Failed to unshortlist talent",
      );
    },
  });
};
